import React, { createContext, useState } from 'react'
import { Amplify, Auth, Storage } from 'aws-amplify'
//import { useNavigate } from "react-router-dom";

const AuthContext = createContext();

function downloadBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename || 'download';
  const clickHandler = () => {
    setTimeout(() => {
      URL.revokeObjectURL(url);
      a.removeEventListener('click', clickHandler);
    }, 150);
  };
  a.addEventListener('click', clickHandler, false);
  a.click();
  return a;  
}

const Authentication = (props) => {

  const [user, setUser] = useState(null);
  const [username, setUsername] = useState('');
  let signup_user = null;
  //const navigate = useNavigate();

  Amplify.configure
    ({
        Auth: {
          identityPoolId: 'us-east-2:3ff303eb-8521-4045-b03b-b4ef981125bf', //REQUIRED - Amazon Cognito Identity Pool ID
          region: 'us-east-2', // REQUIRED - Amazon Cognito Region
          userPoolId: 'us-east-2_MknsnE2ek', //OPTIONAL - Amazon Cognito User Pool ID
          userPoolWebClientId: '6t9gu9i5avd7rilb7p32h4suiq', //OPTIONAL - Amazon Cognito Web Client ID
        },
        Storage: {
          AWSS3: {
              bucket: "portal-fanttech-shapefile-bucket",
              region: "us-east-2"
          }
        },
    });

    async function signIn(username, password) {
      try {
        const user = await Auth.signIn(username, password);
        console.log(user.username);
        setUser(user);
        return user;
      } catch (error) {
        console.log('error signing in', error);
        throw error;
      }
    }

    async function signOut () {
      try {
        await Auth.signOut();
      } catch (error) {
        console.log('erro de logout: ', error);
      }
    }

    async function signUp(username, password, email, name, cpf, phone) {
      try {
        signup_user = await Auth.signUp({
          username,
          password,
          attributes: {
            email, //optional
            name, 
            "custom:CPF": cpf,
            "phone_number": phone, //optional - E.164 number convention
            // other custom attributes
          },
          autoSignIn: {
            // optional - enables auto sign in after user is confirmed
            enabled: true
          }
        });
        console.log(signup_user);
        //user = signup_user.user;
        return signup_user;
        //Deu certo, pular para a tela de verificação  
        //navigate("/verificacao");
      } catch (error) {
        console.log('error signing up:', error);
        /*switch(error.name)
        {
          case 'InvalidPasswordException':
              setErrorMessage("Senha deve conter: mín. 8 caracteres, mín. 1 número, mín. 1 caractere especial (#!@$%), mín. 1 letra maiúscula, mín. 1 letra minúscula")
              setAlertVisibility(true);
        } */       
        return error;
      }
    }

    async function getAuthUser() {
      try {
        const user = await Auth.currentAuthenticatedUser({
          bypassCache: false // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
        });
        setUser(user);
        return user;
      } catch(err) {
        console.log(err);
      }
    };

    async function signOut () {
      try {
        await Auth.signOut();
      } catch (error) {
        console.log('erro de logout: ', error);
      }
    }

    async function uploadFile (fileName, file) {
      return await Storage.put(fileName, file, {
          level: "private",
      });
    }

    async function downloadFile (fileKey, filename) {
      // get the signed URL string
      const signedURL = await Storage.get(fileKey, {
        level: "private",
        download: true
      });
      console.log("signedURL ", signedURL);
      downloadBlob(signedURL.Body, filename)
    }

    async function readShapefiles (fileKey) {
      const signedURL = await Storage.get(fileKey, {
        level: "private",
        download: true
      });
      console.log("signedURL ", signedURL);
      return signedURL;
    }

    async function deleteShapefile (fileKey) {
      console.log(fileKey);
      const oi = await Storage.remove(fileKey, { level: 'private' });
      return oi;
    }


  return (
    <AuthContext.Provider value={
      { 
        signIn, 
        signOut, 
        signUp, 
        signOut, 
        getAuthUser, 
        user, 
        setUser, 
        username, 
        setUsername, 
        uploadFile, 
        downloadFile,
        readShapefiles,
        deleteShapefile
      }}>
        {props.children}
    </AuthContext.Provider>
  )
}

export { Authentication, AuthContext }